class EventTileController {

    constructor(basket, $window) {
        this.basket = basket;
        this.$window = $window;
    }

    url () {
        this.basket.contents.suggested_event = `${this.event.type_name}:${this.event.id}`;

        this.setBasketOffer();

        return this.basket.submit().then(() => this.travel());
    }

    setBasketOffer () {
        if (this.event.offer && this.event.offer > 0) {
            this.basket.contents.store_offer = this.event.offer;
            return;
        }
        if (this.event.availability && this.event.availability.offer) {
            this.basket.contents.store_offer = this.event.availability.offer.id;
        }
    }

    travel () {
        let typeName = this.type;
        switch (typeName) {
            case 'Spa Day':
            case 'SpaDay':
                typeName = 'spa-day';
                break;
            default:
                typeName = typeName.toLowerCase();
                break;
        }
        this.$window.location = `//${this.basket.contents.property.slug}.${this.$window.config.domain}/${typeName}/${this.event.slug}`;
    }

    displayOfferName () {
        return this.event && this.event.availability && this.event.availability.offer && this.event.availability.offer.name;
    }

    shouldDisplayPrice () {
        return !!(this.event.availability && this.event.availability.price && !this.event.availability.phone_only);
    }

    hasReducedPrice () {
        return this.event.availability.price !== this.event.availability.original_price;
    }
}

EventTileController.$inject = ['basket', '$window'];

export default EventTileController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/widget/controllers/event.tile.controller.js